import { Component, Input, Output, ViewChild, EventEmitter } from '@angular/core';

@Component({
    selector: 'input-radio-search',
    templateUrl: './input-radio-search.component.html',
    styleUrls: ['./input-radio-search.component.scss'],
})
export class InputRadioSearchComponent {

    @Input('data') Data: { Code: string, Description: string, Checked?: boolean }[] = [];
    @Input('disabled') IsDisabled: boolean = false;
    @Input('value') FieldValue: any = null;

    @Input('textPlaceholder') Placeholder: string = 'indique o valor';

    @ViewChild('popover') popover;

    @Output('callback') callback: EventEmitter<any> = new EventEmitter<any>();

    public IsOpen: boolean = false;

    constructor() { }

    /** Texto do campo: `[código] descrição` (não só o código). */
    get DisplayText(): string {
        if (!this.FieldValue) return '';
        if (typeof this.FieldValue === 'string') return this.FieldValue;
        return `[${this.FieldValue?.Code || '--'}] ${this.FieldValue?.Description || ''}`.trim();
    }

    public IsSelected(item: any): boolean {
        return !!this.FieldValue && item?.Code === this.FieldValue?.Code;
    }

    public IsItemDisabled(item: any): boolean {
        return item?.ListCAE?.length === 0;
    }

    /** Altura da lista ajustada ao conteúdo (até 8 linhas visíveis, depois faz scroll). */
    public ViewportHeight(count: number): number {
        if (!count) return 72; // espaço para "sem resultados"
        return Math.min(count, 8) * 40;
    }

    public OnPresentPopover(e: Event) {
        if (this.IsDisabled) return;

        this.popover.event = e;
        this.IsOpen = true;
    }

    /** Seleção por clique na linha inteira. */
    public Select(item: any) {
        if (this.IsDisabled || this.IsItemDisabled(item)) return;

        this.FieldValue = item;
        this.IsOpen = false;

        if (this.callback)
            this.callback.emit(this.FieldValue);
    }

    public trackByFn(index, item) {
        return item?.Code ?? index;
    }
}
